import firebase from 'firebase/compat/app';

const getStorageRef = (filePath: string) => firebase.storage().ref(filePath);

export default getStorageRef;
